import { Reveal, Eyebrow } from "@/components/Reveal";

const STEPS = [
    {
        n: "01",
        title: "Contattaci",
        text: "Il cliente ci racconta la propria esigenza.",
    },
    {
        n: "02",
        title: "Analizziamo la richiesta",
        text: "Valutiamo il pezzo, il progetto o la lavorazione richiesta.",
    },
    {
        n: "03",
        title: "Realizziamo",
        text: "Procediamo con la lavorazione utilizzando le attrezzature più adatte.",
    },
    {
        n: "04",
        title: "Consegniamo",
        text: "Il risultato viene completato secondo le specifiche concordate.",
    },
];

export default function Processo() {
    return (
        <section
            data-testid="processo-section"
            className="blueprint-grid-dark bg-tl-light py-20 md:py-28"
        >
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
                <Reveal>
                    <Eyebrow number="06" label="Come lavoriamo" dark />
                </Reveal>
                <Reveal delay={0.1}>
                    <h2 className="mt-6 font-display text-2xl font-bold tracking-tight text-tl-ink sm:text-3xl lg:text-4xl">
                        Dal progetto al risultato
                        <span className="text-tl-orange">.</span>
                    </h2>
                </Reveal>

                <ol className="mt-14 grid gap-10 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    {STEPS.map((s, i) => (
                        <Reveal key={s.n} delay={0.08 * i} y={24}>
                            <li
                                data-testid={`processo-step-${i}`}
                                className="relative border-t-2 border-tl-ink/15 pt-8"
                            >
                                <span className="absolute -top-[2px] left-0 h-[2px] w-12 bg-tl-orange" />
                                <span className="font-mono-tl text-sm font-semibold tracking-[0.2em] text-tl-orange">
                                    {s.n}
                                </span>
                                <h3 className="mt-4 font-display text-xl font-bold tracking-tight text-tl-ink">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sm leading-relaxed text-tl-mutedDark">
                                    {s.text}
                                </p>
                            </li>
                        </Reveal>
                    ))}
                </ol>
            </div>
        </section>
    );
}
